export default "__VITE_ASSET__badca790__"